/* De dónde vino una sesión, en palabras · carril ops (19 sep 2026).
   El mismo criterio que backend/app/ops/dispositivo.py: red local de la
   empresa (RFC 1918, Tailscale) o internet. Sin geolocalización: lo
   mínimo honesto. */
const LOCALES = [/^10\./, /^192\.168\./, /^172\.(1[6-9]|2\d|3[01])\./, /^100\.(6[4-9]|[7-9]\d|1[01]\d|12[0-7])\./, /^127\./, /^fc|^fd/i, /^::1$/];

export function describirLugar(ip, pais) {
  if (!ip) return 'una dirección que no se registró';
  if (LOCALES.some((r) => r.test(ip))) return `la red local de la empresa (${ip})`;
  return `internet, dirección ${ip}${pais ? ` (${pais})` : ''}`;
}
